// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"076d3b0b","498":"616ae838","513":"bdeac90f"}[chunkId] + ".chunk.js";
};